import { gql } from '@apollo/client';
import { RoutePlanningTemplateOutput } from './listRoutePlanningTemplates';

export const SAVE_ROUTE_PLANNING_TEMPLATE = gql`
    mutation SaveRoutePlanningTemplate($input: SaveRoutePlanningTemplateInput!) {
        saveRoutePlanningTemplate(input: $input) {
            id
            name
            assignType
            isDefault
            driverCount
            details {
                id
                driverAccountId
                driverName
                capacityMin
                capacityMax
                preferredZipcodes
                startAddress {
                    streetAddress
                    city
                    state
                    zipCode
                    latitude
                    longitude
                }
                endAddress {
                    streetAddress
                    city
                    state
                    zipCode
                    latitude
                    longitude
                }
            }
        }
    }
`;

export interface RoutePlanningTemplateDetailInput {
    id?: number | null;
    driverAccountId: number;
    driverName?: string | null;
    capacityMin?: number | null;
    capacityMax?: number | null;
    preferredZipcodes?: string[];
    startAddress?: {
        streetAddress?: string | null;
        city?: string | null;
        state?: string | null;
        zipCode?: string | null;
        latitude?: number | null;
        longitude?: number | null;
    } | null;
    endAddress?: {
        streetAddress?: string | null;
        city?: string | null;
        state?: string | null;
        zipCode?: string | null;
        latitude?: number | null;
        longitude?: number | null;
    } | null;
}

export interface SaveRoutePlanningTemplateInput {
    id?: number | null;
    name: string;
    areaId: number;
    dspId: number;
    warehouseId: number;
    assignType?: number;
    details: RoutePlanningTemplateDetailInput[];
}

export interface SaveRoutePlanningTemplateResponse {
    saveRoutePlanningTemplate: RoutePlanningTemplateOutput;
}

export interface SaveRoutePlanningTemplateVariables {
    input: SaveRoutePlanningTemplateInput;
}
